import { useEffect, useRef, useState } from 'react';

// Bidirectional scroll reveal: animates in both ways depending on which
// edge the element exited through, matching the reference's `io` observer.
export function useReveal() {
  const ref = useRef(null);
  const [state, setState] = useState({ in: false, from: 'bottom' });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setState({ in: true, from: 'bottom' });
      return;
    }

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setState((s) => ({ ...s, in: true }));
        } else {
          setState({ in: false, from: entry.boundingClientRect.top < 0 ? 'top' : 'bottom' });
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return [ref, state];
}
